import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import { sanitizeUrl } from 'javascripts/sanitizer';
import React, { Fragment } from 'react';

const IntegrationContents: React.FC<CardContentsComponent<'integrations'>> = ({
  integrations,
}) => {
  return (
    <>
      {integrations.map((integration, index) => (
        <Fragment key={index}>
          {integration.icon && (
            <img
              src={integration.icon}
              className='small-icon'
              slot='icon'
              title={integration.title}
            />
          )}

          <a
            href={sanitizeUrl(integration.url)}
            target='_blank'
            rel='noopener noreferrer'
          >
            {integration.name}
          </a>
        </Fragment>
      ))}
    </>
  );
};

export default IntegrationContents;
